import fetchDrbApi from './fetchDrbApi';

export const fetchDrbApiEntities = () =>
  fetchDrbApi({ path: '/entities' })
    .then(res => res.json())
    .then(({ content }) => content)
    .catch(err => console.error(err));

export default fetchDrbApiEntities;
